<template>
    <div class="lm-border pa-3">
        <f-title title="Adressen" class="mt-0" />
        <v-row class="mt-0">
            <p-inc-invoice-recipient
                v-model     = "data.benefitRecipient"
                :usage      = "usage"
                :separated  = "separated"
                :type       = "`Leistungsempfänger`"
                :recipients = "benefit"
                :collective = "collective"
            />
        </v-row>
        <v-row class="mt-6">
            <p-inc-invoice-recipient
                v-model     = "data.invoiceRecipient"
                :usage      = "usage"
                :separated  = "separated"
                :type       = "`Rechnungsempfänger`"
                :recipients = "invoice"
                :collective = "collective"
            />
        </v-row>
    </div>
</template>

<script>

import FTitle               from "@/modules/core/components/utils/FTitle.vue";
import PIncInvoiceRecipient from "@/modules/inc/steps/components/invoice/private/PIncInvoiceRecipient.vue";

export default {
    name: "PIncInvoiceRecipients",

    components: {
        FTitle,
        PIncInvoiceRecipient,
    },

    props: {
        recipients: {

        },

        separated: {

        },

        usage: {

        },

        collective: {
            required: false,
            type     : Boolean,
            default  : function () {
                return false;
            }
        },

        data: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    benefitRecipient: null,
                    invoiceRecipient: null,
                    forwardRecipient: null,
                    sites: [
                        {
                            benefit: null,
                            invoice: null,
                            forward: null
                        }
                    ]
                }
            },
        },
    },

    computed: {
        benefit () {
            if (!this.recipients) {
                return null;
            }

            return this.recipients.benefit;
        },

        invoice () {
            if (!this.recipients) {
                return null;
            }

            return this.recipients.invoice;
        },

        forward () {
            if (!this.recipients) {
                return null;
            }

            return this.recipients.forward;
        },
    }
}
</script>

<style scoped>

</style>